/**
 * Auth Service Export
 *
 * Switch automatico tra mock e API reali basato su env.USE_MOCK_DATA.
 * Questo permette di sviluppare il frontend senza backend,
 * e passare alle API reali semplicemente cambiando la variabile d'ambiente.
 */

import { authApi } from './auth.api';
import type { AuthService } from '../types/auth.types';

/**
 * Servizio di autenticazione
 *
 * NOTA: Usa sempre API reali per l'autenticazione.
 * Gli altri moduli (trips, surveys, analytics) possono continuare a usare mock
 * tramite la variabile VITE_USE_MOCK_DATA.
 *
 * @example
 * // Login
 * const response = await authService.login({ email, password });
 *
 * // Valida token esistente
 * const user = await authService.validateToken(token);
 *
 * // Forgot password
 * await authService.forgotPassword(email);
 *
 * // Reset password
 * await authService.resetPassword({ token, password });
 */
export const authService: AuthService = authApi;

// Re-export types per comodità
export type {
  User,
  AuthResponse,
  RefreshTokenResponse,
  LoginRequest,
  ResetPasswordRequest,
  ForgotPasswordRequest,
  TokenValidationResponse,
  AuthService,
} from '../types/auth.types';
